import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import styles from "./EnergyShop.module.scss";
import p1 from "../../../assets/images/current.png";
import { useDispatch, useSelector } from "react-redux";
import {
  getPurchaseLink,
  checkPaymentStatus,
  getUserProfile,
  cancelPayment,
  updateProfile,
  payWithBitanica,
} from "../../../lib/store/actions";
import { useTonAddress, useTonConnectUI } from "@tonconnect/ui-react";
import { isMobile, showToast } from "../../../helper/common";
import VerifyingPaymentLoader from "../../Loader/verifyPayment";
import tokenIcn from "../../../assets/images/usdt-ton.png";
import CustomLoader from "../../Loader/index";
import cardIcn from "../../../assets/images/card.png";
import bPay from "../../../assets/images/bitanicapay.png";
import {
  getUsdtWalletAddress,
  getNetworkName,
  usePreventTonModalClose,
} from "../../../helper/common";
import styled from "styled-components";
const GAS_FEE = "50000000";

const EnergyShop = ({
  showEnergyPackage,
  setShowEnergyPackage,
  packageItem,
  setBitanicaIframe,
  setIframeData,
}) => {
  usePreventTonModalClose();
  const [step, setStep] = useState(1);
  const [selectedCurrency, setSelectedCurrency] = useState("Crypto");
  const [bpayPaymentMethod, setBpayPaymentMethod] = useState();
  const [loading, setLoading] = useState(false);
  const [tonConnectUI] = useTonConnectUI();
  const [verify, setVerify] = useState(false);
  const userFriendlyAddress = useTonAddress();

  const dispatch = useDispatch();
  const { settingsData, userData } = useSelector(({ Settings, Auth }) => ({
    userData: Auth.user,
    settingsData: Settings.settings,
  }));

  const handlePurchase = async (packageId, energy) => {
    if (verify) {
      showToast("Please wait for previous transaction completion", "error");
    }
    if (
      settingsData?.energy?.maxEnergyBalance <
      userData.energyBalance + energy
    ) {
      showToast("Purchase not allowed—exceeds max energy limit.", "info");
      return;
    }

    if (tonConnectUI && !tonConnectUI?.connected) {
      await tonConnectUI.connectWallet();
      if (tonConnectUI?.account) {
        const networkName = getNetworkName(tonConnectUI?.account?.chain);
        const targetNetwork = settingsData?.payment?.tonNetwork;
        if (networkName !== targetNetwork) {
          showToast(
            `Please switch your wallet network manually to ${targetNetwork} and reconnect!`,
            "error",
          );
          return;
        }
      }
      setLoading(true);
      dispatch(
        updateProfile({
          data: {
            _id: userData?._id,
            walletAddress: tonConnectUI?.account?.address,
          },
          callBack: (err, data) => {
            if (err) {
              setLoading(false);
              return;
            }
            dispatch(
              getPurchaseLink({
                data: {
                  quantity: 1,
                  energyPackageId: packageId,
                },
                callBack: async (err, res) => {
                  if (err) {
                    setLoading(false);
                    showToast("Network Error! Please try later.", "error");
                    return;
                  }
                  setLoading(!loading);
                  const { purchaseID, payload } = res.data;
                  if (tonConnectUI?.connected) {
                    const userTonAddress = tonConnectUI?.account?.address;
                    const userUSDTAddress = await getUsdtWalletAddress(
                      userTonAddress,
                      settingsData,
                    );
                    if (userUSDTAddress) {
                      try {
                        await tonConnectUI.sendTransaction({
                          validUntil: Math.floor(Date.now() / 1000) + 300,
                          // network: settingsData?.payment?.tonNetwork,
                          messages: [
                            {
                              address: userUSDTAddress || userTonAddress,
                              amount: GAS_FEE,
                              payload: payload,
                            },
                          ],
                        });

                        setLoading(false);
                        setVerify(true);
                        await verifyPayment(purchaseID);
                      } catch (error) {
                        setLoading(false);
                        setVerify(false);
                        showToast("Transaction was cancelled!", "error");
                      }
                    } else {
                      showToast("USDT Wallet not found!", "error");
                      setLoading(false);
                      setVerify(false);
                      hidePopup();
                    }
                  }
                },
              }),
            );
          },
        }),
      );
    } else if (tonConnectUI?.connected) {
      if (tonConnectUI?.account) {
        const networkName = getNetworkName(tonConnectUI?.account?.chain);
        const targetNetwork = settingsData?.payment?.tonNetwork;
        if (networkName !== targetNetwork) {
          showToast(
            `Please switch your wallet network manually to ${targetNetwork}`,
            "error",
          );
          return;
        }
      }
      setLoading(!loading);
      dispatch(
        getPurchaseLink({
          data: {
            quantity: 1,
            energyPackageId: packageId,
          },
          callBack: async (err, res) => {
            if (err) {
              setLoading(false);
              showToast("Network Error! Please try later.", "error");
              return;
            }
            setLoading(!loading);
            const { purchaseID, payload } = res.data;
            if (tonConnectUI?.connected) {
              const userTonAddress = tonConnectUI?.account?.address;
              const userUSDTAddress = await getUsdtWalletAddress(
                userTonAddress,
                settingsData,
              );
              try {
                await tonConnectUI.sendTransaction({
                  validUntil: Math.floor(Date.now() / 1000) + 300,
                  // network: settingsData?.payment?.tonNetwork,
                  messages: [
                    {
                      address: userUSDTAddress || userTonAddress,
                      amount: GAS_FEE,
                      payload: payload,
                    },
                  ],
                });
                setLoading(false);
                setVerify(true);
                await verifyPayment(purchaseID);
              } catch (error) {
                setLoading(false);
                setVerify(false);
                showToast("Transaction was cancelled!", "error");
                dispatch(
                  cancelPayment({
                    data: {
                      purchaseID: purchaseID,
                    },
                    callBack: async (err, res) => {
                      if (err) {
                      }
                    },
                  }),
                );
              }
            }
          },
        }),
      );
    } else {
      showToast("Please connect telegram wallet!", "error");
      setLoading(false);
    }
  };

  const verifyPayment = async (purchaseID) => {
    try {
      const checkPayment = async (attempts = 0) => {
        if (attempts > 20) {
          throw new Error("Timeout waiting for payment");
        }
        if (!purchaseID) {
          throw new Error("No purchase ID provided");
        }
        try {
          const res = await dispatch(
            checkPaymentStatus({ data: { purchaseID } }),
          ).unwrap();
          if (res?.status === "success") {
            setVerify(false);
            showToast("Package Purchased Successfully!", "success");
            hidePopup();
            dispatch(
              getUserProfile({
                data: {
                  _id: userData?._id,
                },
                callBack: (err, res) => {
                  if (err) return;
                },
              }),
            );
            return;
          } else {
            await new Promise((resolve) => setTimeout(resolve, 5000));
            return await checkPayment(attempts + 1);
          }
        } catch (err) {
          console.error("Error checking payment:", err);
          setVerify(false);
          setLoading(false);
          hidePopup();
          showToast("Package Payment timeout!", "error");
        }
      };
      await checkPayment();
    } catch (error) {
      console.error("Verification error:", error);
      setVerify(false);
      setLoading(false);
      hidePopup();
      showToast("Package Payment timeout!", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleShop = async (packageId, energy) => {
    if (
      settingsData?.energy?.maxEnergyBalance <
      userData.energyBalance + energy
    ) {
      showToast("Purchase not allowed—exceeds max energy limit.", "info");
      return;
    }
    if (verify) {
      showToast("Please wait for previous transaction completion", "error");
    }
    setLoading(true);
    let bodyParams = {
      quantity: 1,
      energyPackageId: packageId,
      platform: "web",
    };
    const mobile = isMobile();
    if (window.Telegram && window.Telegram.WebApp && mobile) {
      bodyParams.platform = "bot";
    }
    // dispatch(
    //   getOrderLink({
    //     data: bodyParams,
    //     callBack: async (err, res) => {
    //       if (err) {
    //         setLoading(false);
    //         showToast("Network Error! Please try later.", "error");
    //         hidePopup();
    //         return;
    //       }
    //       setLoading(false);
    //       if (window.Telegram && window.Telegram.WebApp) {
    //         localStorage.setItem(
    //           "pendingPayment",
    //           JSON.stringify({
    //             order_id: res?.data?.order_id,
    //             purchaseID: res?.data?.purchaseID,
    //             timestamp: Date.now(),
    //           })
    //         );
    //         window.Telegram.WebApp.openLink(res?.data?.payment_url);
    //       } else {
    //         localStorage.setItem(
    //           "pendingPayment",
    //           JSON.stringify({
    //             order_id: res?.data?.order_id,
    //             purchaseID: res?.data?.purchaseID,
    //             timestamp: Date.now(),
    //           })
    //         );
    //         window.open(res?.data?.payment_url, "_blank");
    //       }
    //       hidePopup();
    //     },
    //   })
    // );
  };

  const handleBitanicaPay = async (packageId, energy, bpaymethod) => {
    if (
      settingsData?.energy?.maxEnergyBalance <
      userData.energyBalance + energy
    ) {
      showToast("Purchase not allowed—exceeds max energy limit.", "info");
      return;
    }

    if (verify) {
      showToast("Please wait for previous transaction completion", "error");
    }

    setLoading(true);
    let bodyParams = {
      quantity: 1,
      energyPackageId: packageId,
      platform: "web",
      payment_method: bpaymethod,
    };

    const mobile = isMobile();
    if (window.Telegram && window.Telegram.WebApp && mobile) {
      bodyParams.platform = "bot";
    }

    dispatch(
      payWithBitanica({
        data: bodyParams,
        callBack: async (err, res) => {
          if (err) {
            setLoading(false);
            showToast("Network Error! Please try later.", "error");
            hidePopup();
            return;
          }

          setLoading(false);

          if (window.Telegram && window.Telegram.WebApp) {
            // localStorage.setItem(
            //   "pendingPayment",
            //   JSON.stringify({
            //     order_id: res?.data?.order_id,
            //     purchaseID: res?.data?.purchaseID,
            //     timestamp: Date.now(),
            //   })
            // );
            // window.Telegram.WebApp.openLink(res?.data?.iframe_url);
            setBitanicaIframe(true);
            setIframeData(res?.data);
          } else {
            // localStorage.setItem(
            //   "pendingPayment",
            //   JSON.stringify({
            //     order_id: res?.data?.order_id,
            //     purchaseID: res?.data?.purchaseID,
            //     timestamp: Date.now(),
            //   })
            // );
            setBitanicaIframe(true);
            setIframeData(res?.data);
            // window.open(res?.data?.iframe_url, "_blank");
          }

          hidePopup();
        },
      }),
    );
  };

  const hidePopup = () => {
    setShowEnergyPackage(false);
  };

  return (
    <>
      {verify && <VerifyingPaymentLoader />}
      {loading && <CustomLoader />}
      <Modal
        show={showEnergyPackage}
        onHide={hidePopup}
        backdrop="true"
        centered
        scrollable="true"
        className={`${styles.EnergyShop} bottomPop`}
        keyboard={false}
      >
        <div className="modalWrpper">
          <Modal.Body>
            <Button
              onClick={hidePopup}
              variant="transparent"
              className="border-0 p-0 position-absolute"
              style={{ top: 15, right: 15 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                  fill="#506380"
                />
              </svg>
            </Button>
            <div
              //   style={{ maxWidth: 344 }}
              className="mx-auto"
            >
              <div className="top pb-3 text-center">
                {step == 1 ? (
                  <h5 className="m-0 themeClr2 d-inline-block pb-1 fw-bold">
                    Energy Shop
                  </h5>
                ) : (
                  <h5
                    className="m-0 text-white d-inline-block pb-1 fw-bold"
                    style={{ borderBottom: "0.2px solid #07ECF9" }}
                  >
                    PAYMENT METHODS
                  </h5>
                )}
              </div>
              {step == 1 ? (
                <>
                  <div className="py-2">
                    <div
                      className={`${styles.box} shadow-sm position-relative mx-auto text-center rounded-4 p-3`}
                      // style={{ maxWidth: 290 }}
                    >
                      <div className="">
                        <div className="d-flex align-items-center gap-10">
                          <div
                            className="flex-shrink-0 position-relative text-start"
                            style={{ width: "55%" }}
                          >
                            {packageItem?.isHotOffer && (
                              <div
                                className={`${styles.hotOffer} position-absolute d-flex align-items-center px-2`}
                                style={{
                                  background: "#242AFC",
                                  top: -17,
                                  left: 0,
                                }}
                              >
                                <span className="icn me-1">{clockIcn}</span>
                                <p className="m-0 text-white">Hot offer</p>
                              </div>
                            )}
                            <img
                              src={packageItem?.logo}
                              alt=""
                              className="img-fluid"
                              style={{
                                height: "100%",
                                maxHeight: 102,
                                marginTop: 10,
                                marginBottom: 5,
                              }}
                            />
                          </div>

                          <div className="text-center d-flex align-items-center gap-10">
                            <img
                              src={p1}
                              alt=""
                              className="img-fluid flex-shrink-0"
                              style={{ height: 28 }}
                            />
                            <h4
                              style={{ fontSize: 32 }}
                              className="m-0 fw-bold text-white"
                            >
                              {packageItem?.energy}
                              <span className="" style={{ fontSize: 16 }}>
                                X
                              </span>
                            </h4>
                          </div>
                        </div>
                      </div>
                      <div className="">
                        <p className="m-0 fw-sbold text-white">
                          Get
                          {packageItem?.energy}
                          energy & enjoy Bitanica Mines
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="">
                    <p className="m-0 pt-2 text-white text-start fw-light">
                      Choose Payment Method
                    </p>
                    <RadioSelect className="mt-2 d-flex align-items-center flex-wrap justify-content-center">
                      <div className="px-2 w-50">
                        <label className=" w-100 position-relative ">
                          {/* <input
                        type="radio"
                        className="position-absolute h-100 w-100 "
                        name="currency"
                        value="Credit Card"
                        checked={selectedCurrency === "Credit Card"}
                        onClick={() => setSelectedCurrency("Credit Card")}
                        style={{
                          cursor: "pointer",
                          left: 0,
                          top: 0,
                          zIndex: 999,
                          opacity: 0,
                        }}
                      /> */}
                          <div
                            onClick={() => {
                              setStep(2);
                              setSelectedCurrency("");
                            }}
                            className="d-flex align-items-center text-white cursor-pointer justify-content-between px-2 py-1"
                          >
                            <div className="left d-flex align-items-center gap-10">
                              <div className="rounded-circle radioCstm d-flex align-items-center justify-content-center">
                                <div className="rounded-circle"></div>
                              </div>{" "}
                              Credit Card
                            </div>
                            <span className="icn">
                              <img
                                src={cardIcn}
                                alt="card"
                                className="img-fluid"
                                style={{ height: 20 }}
                              />
                            </span>
                          </div>
                        </label>
                      </div>
                      <div className="px-2 w-50">
                        <label className=" w-100 position-relative ">
                          {/* <input
                            type="radio"
                            className="position-absolute h-100 w-100 "
                            name="currency"
                            value="Crypto"
                            checked={selectedCurrency === "Crypto"}
                            onClick={() => setSelectedCurrency("Crypto")}
                            style={{
                              cursor: "pointer",
                              left: 0,
                              top: 0,
                              zIndex: 999,
                              opacity: 0,
                            }}
                          /> */}
                          <div
                            onClick={() => {
                              setStep(3);
                              setSelectedCurrency("");
                            }}
                            className="d-flex align-items-center text-white cursor-pointer justify-content-between px-2 py-1"
                          >
                            <div className="left d-flex align-items-center gap-10">
                              <div className="rounded-circle radioCstm d-flex align-items-center justify-content-center">
                                <div className="rounded-circle"></div>
                              </div>{" "}
                              Crypto
                            </div>
                            {/* <span>Buy with</span> */}
                            <span className="icn">
                              <img
                                src={tokenIcn}
                                alt="USDT"
                                className="img-fluid"
                                style={{ height: 20 }}
                              />
                            </span>
                          </div>
                        </label>
                      </div>
                    </RadioSelect>
                  </div>
                </>
              ) : step == 2 ? (
                <>
                  <div className="">
                    <RadioSelect className="mt-2 d-flex flex-column align-items-center flex-wrap justify-content-center">
                      {/* <div className=" w-100">
                        <label className=" w-100 position-relative ">
                          <input
                            type="radio"
                            className="position-absolute h-100 w-100 "
                            name="currency"
                            value="Credit Card"
                            checked={selectedCurrency === "Credit Card"}
                            onClick={() => setSelectedCurrency("Credit Card")}
                            style={{
                              cursor: "pointer",
                              left: 0,
                              top: 0,
                              zIndex: 999,
                              opacity: 0,
                            }}
                          />
                          <div className="text-white cursor-pointer p-3 ">
                            <div className="d-flex align-items-center text-white cursor-pointer justify-content-between py-2 ">
                              <div className="left d-flex align-items-center gap-10">
                                <div className="rounded-circle radioCstm d-flex align-items-center justify-content-center">
                                  <div className="rounded-circle"></div>
                                </div>{" "}
                                Credit Card
                              </div>
                              <span className="icn">
                                <img
                                  src={cardIcn}
                                  alt="card"
                                  className="img-fluid"
                                  style={{ height: 20 }}
                                />
                              </span>
                            </div>
                            <div
                              className="d-flex flex-wrap  gap-2 pt-2"
                              style={{
                                borderTop: "1px solid rgba(255,255,255,0.08)",
                                fontSize: 12,
                              }}
                            >
                              <span className="text-white fw-sbold">
                                Supported in
                              </span>
                              <div className="d-flex align-items-center gap-3 flex-wrap">
                                <div className="d-flex align-items-center gap-1">
                                  {flagAZ}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    AZ
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagTJ}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    TJ
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagKG}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    KG
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagUZ}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    UZ
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </label>
                      </div>
                      <LineSeperator className="position-relative text-center d-flex justify-content-center align-items-center my-3 w-100">
                        <p className="m-0 px-2 position-relative text-white">
                          Or Buy with
                        </p>
                      </LineSeperator> */}
                      <div className=" w-100">
                        <label
                          className=" w-100 position-relative "
                          // style={{ opacity: "40%" }}
                        >
                          <input
                            type="radio"
                            className="position-absolute h-100 w-100 "
                            name="currency"
                            value="Bitanica pay"
                            checked={selectedCurrency === "Bitanica Pay"}
                            onClick={() => setSelectedCurrency("Bitanica Pay")}
                            style={{
                              cursor: "pointer",
                              left: 0,
                              top: 0,
                              zIndex: 999,
                              opacity: 0,
                            }}
                          />
                          <div className="text-white cursor-pointer p-3 ">
                            <div className="d-flex align-items-center justify-content-between py-2">
                              <div className="left d-flex align-items-center gap-10">
                                <div className="rounded-circle radioCstm d-flex align-items-center justify-content-center">
                                  <div className="rounded-circle"></div>
                                </div>{" "}
                                Bitanica pay
                              </div>
                              <span className="icn">
                                <img
                                  src={bPay}
                                  alt="card"
                                  className="img-fluid"
                                  style={{ height: 20 }}
                                />
                              </span>
                            </div>
                            <div
                              className="d-flex flex-wrap gap-2 pt-2"
                              style={{
                                borderTop: "1px solid rgba(255,255,255,0.08)",
                                fontSize: 12,
                              }}
                            >
                              <span className="text-white fw-sbold">
                                Supported in
                              </span>
                              <div className="d-flex align-items-center gap-3 flex-wrap">
                                <div className="d-flex align-items-center gap-1">
                                  {flagAZ}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    AZ
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagUA}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    UA
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagKZ}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    KZ
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagTR}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    TR
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagEE}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    EE
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagIT}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    IT
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagPL}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    PL
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagES}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    ES
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagFR}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    FR
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagGE}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    GE
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </label>
                        {/* <p className="m-0 text-center text-danger">
                          Under maintenance
                        </p> */}
                      </div>
                    </RadioSelect>
                  </div>
                  {/* <Note className="d-flex align-items-center gap-10 p-3 mt-3">
                    <span className="flex-shrink-0">{noteIcn}</span>
                    <p className="m-0">
                      Credit/Debit Card payments are only supported in AZN
                      (Azerbaijan), TJS (Tajikistan), KGS (Kyrgyzstan), and UZS
                      (Uzbekistan).
                    </p>
                  </Note> */}
                </>
              ) : step == 3 ? (
                <>
                  <div className="">
                    <RadioSelect className="mt-2 d-flex flex-column align-items-center flex-wrap justify-content-center">
                      <div className=" w-100">
                        <label
                          className=" w-100 position-relative "
                          // style={{ opacity: "40%" }}
                        >
                          <input
                            type="radio"
                            className="position-absolute h-100 w-100 "
                            name="currency"
                            value="Bitanica pay"
                            checked={selectedCurrency === "Bitanica Pay"}
                            onClick={() => {
                              setSelectedCurrency("Bitanica Pay");
                              setBpayPaymentMethod("crypto");
                            }}
                            style={{
                              cursor: "pointer",
                              left: 0,
                              top: 0,
                              zIndex: 999,
                              opacity: 0,
                            }}
                          />
                          <div className="text-white cursor-pointer p-3 ">
                            <div className="d-flex align-items-center justify-content-between py-2">
                              <div className="left d-flex align-items-center gap-10">
                                <div className="rounded-circle radioCstm d-flex align-items-center justify-content-center">
                                  <div className="rounded-circle"></div>
                                </div>{" "}
                                Bitanica pay
                              </div>
                              <span className="icn">
                                <img
                                  src={bPay}
                                  alt="card"
                                  className="img-fluid"
                                  style={{ height: 20 }}
                                />
                              </span>
                            </div>
                            <div
                              className="d-flex flex-wrap gap-2 pt-2"
                              style={{
                                borderTop: "1px solid rgba(255,255,255,0.08)",
                                fontSize: 12,
                              }}
                            >
                              <span className="text-white fw-sbold">
                                Supported in
                              </span>
                              <div className="d-flex align-items-center gap-3 flex-wrap">
                                <div className="d-flex align-items-center gap-1">
                                  {flagAZ}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    AZ
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagUA}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    UA
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagKZ}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    KZ
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagTR}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    TR
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagEE}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    EE
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagIT}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    IT
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagPL}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    PL
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagES}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    ES
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagFR}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    FR
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagGE}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    GE
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </label>
                        {/* <p className="m-0 text-center text-danger">
                          Under maintenance
                        </p> */}
                      </div>

                      <LineSeperator className="position-relative text-center d-flex justify-content-center align-items-center my-3 w-100">
                        <p className="m-0 px-2 position-relative text-white">
                          Or Buy with
                        </p>
                      </LineSeperator>
                      <div className="px-2 w-100">
                        <label className=" w-100 position-relative ">
                          <input
                            type="radio"
                            className="position-absolute h-100 w-100 "
                            name="currency"
                            value="Crypto"
                            checked={selectedCurrency === "Crypto"}
                            onClick={() => setSelectedCurrency("Crypto")}
                            style={{
                              cursor: "pointer",
                              left: 0,
                              top: 0,
                              zIndex: 999,
                              opacity: 0,
                            }}
                          />
                          <div className="d-flex align-items-center text-white cursor-pointer justify-content-between px-2 py-1">
                            <div className="left d-flex align-items-center gap-10">
                              <div className="rounded-circle radioCstm d-flex align-items-center justify-content-center">
                                <div className="rounded-circle"></div>
                              </div>{" "}
                              Crypto
                            </div>
                            {/* <span>Buy with</span> */}
                            <span className="icn">
                              <img
                                src={tokenIcn}
                                alt="USDT"
                                className="img-fluid"
                                style={{ height: 20 }}
                              />
                            </span>
                          </div>
                        </label>
                      </div>
                    </RadioSelect>
                  </div>
                </>
              ) : (
                <></>
              )}

              <p
                className="text-center mt-2"
                style={{ height: 50, color: "#EBF049" }}
              >
                {selectedCurrency === "Crypto" &&
                  "USDT must be sent via TON chain. A small amount of TON is required for fees."}
                {/* selectedCurrency === "Credit Card" ? `Fiat Price: ₾ ${packageItem?.gelPrice?.toFixed(2)}` : "" */}
              </p>
              <div className="mt-2 text-center d-flex ">
                <Button
                  style={{
                    height: 48,
                    width: "100%",
                  }}
                  onClick={() => {
                    if (selectedCurrency === "Crypto") {
                      handlePurchase(packageItem?._id, packageItem?.energy);
                    } else if (selectedCurrency === "Bitanica Pay") {
                      handleBitanicaPay(
                        packageItem?._id,
                        packageItem?.energy,
                        bpayPaymentMethod,
                      );
                    }
                  }}
                  disabled={!packageItem || !selectedCurrency}
                  className={`${styles.submitBtn} ${
                    !packageItem || (!selectedCurrency && styles.disabled)
                  } d-inline-flex align-items-center justify-content-center fw-bold commonBtn border-0 mb-4`}
                >
                  {packageItem ? (
                    <>
                      Buy for{" "}
                      {selectedCurrency === "Crypto" && (
                        <img
                          src={tokenIcn}
                          style={{ height: 20, width: 20 }}
                          alt=""
                          className="img-fluid flex-shrink-0 object-fit-contain mx-2"
                        />
                      )}{" "}
                      {selectedCurrency === "Crypto" ? (
                        packageItem.discountedPrice
                      ) : (
                        <>
                          <img
                            src={tokenIcn}
                            style={{ height: 20, width: 20 }}
                            alt=""
                            className="img-fluid flex-shrink-0 object-fit-contain mx-2"
                          />
                          {packageItem.discountedPrice}
                        </>
                      )}
                    </>
                  ) : (
                    "Buy"
                  )}
                </Button>

                {/* <Button
                                    style={{
                                        height: 48,
                                        width: "50%"
                                    }}
                                    disabled={!packageItem}
                                    onClick={() => { handleShop(packageItem?._id, packageItem?.energy) }}
                                    className={`${styles.submitBtn} d-inline-flex align-items-center justify-content-center fw-bold commonBtn border-0 mb-4`}
                                >
                                    <span>Buy for GEL {packageItem?.gelPrice}</span>
                                </Button> */}
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

const LineSeperator = styled.div`
  z-index: 99;
  &:after {
    position: absolute;
    content: "";
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 1px;
    width: 100%;
    background: #1d1d20;
  }
  p {
    background: #0e0e11;
    z-index: 99;
    font-weight: 500;
  }
`;

const Note = styled.div`
  background: #3e2b10;
  border-radius: 20px;
  color: #ff9f0a;
`;
const RadioSelect = styled.div`
  > div {
    width: 33.333%;
  }
  label {
    > div {
      background: #1b223a;
      border-radius: 10px;
      min-height: 60px;
      font-size: 13px;
      font-family: "Space Grotesk", sans-serif;
      font-weight: 500;
      border: 1px solid transparent;
      .radioCstm {
        height: 16px;
        width: 16px;
        background: #0e0e11;
        padding: 1px;
        div {
          height: 8px;
          width: 8px;
          background: #242afc;
          opacity: 0;
        }
      }
    }
  }
  input:checked + div {
    opacity: 1;
    border-color: #242afc;
    .radioCstm {
      div {
        opacity: 1;
      }
    }
  }
`;
export default EnergyShop;

const clockIcn = (
  <svg
    width="9"
    height="9"
    viewBox="0 0 7 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.22932 3.80942C6.22932 5.20066 5.10214 6.32978 3.71329 6.32978C2.32445 6.32978 1.19727 5.20066 1.19727 3.80942C1.19727 2.41818 2.32445 1.28906 3.71329 1.28906C5.10214 1.28906 6.22932 2.41818 6.22932 3.80942Z"
      stroke="white"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.64763 4.61085L3.86766 4.14458C3.7318 4.06393 3.62109 3.86986 3.62109 3.71108V2.67773"
      stroke="white"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const noteIcn = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10.75" cy="10.75" r="10" stroke="#FF9F0A" strokeWidth="1.5" />
    <path
      d="M10.742 13.75H10.751"
      stroke="#FF9F0A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.75 10.75L10.75 6.75"
      stroke="#FF9F0A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const flagAZ = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_az)">
      <mask
        id="mask0_az"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_az)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#E3002E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 11.4287H24V17.143H0V11.4287Z"
          fill="#00AF62"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H24V5.71429H0V0Z"
          fill="#0097C5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.7144 8H14.8572V9.14286H13.7144V8Z"
          fill="#FBDCE2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2859 10.2853C13.7648 10.979 12.9351 11.4282 12.0002 11.4282C10.4231 11.4282 9.14307 10.1482 9.14307 8.57101C9.14307 6.99387 10.4231 5.71387 12.0002 5.71387C12.9351 5.71387 13.7648 6.16301 14.2859 6.85672H12.5716C11.6254 6.85672 10.8574 7.62472 10.8574 8.57101C10.8574 9.5173 11.6254 10.2853 12.5716 10.2853H14.2859Z"
          fill="white"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_az">
        <rect width="24" height="17.1429" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const flagTJ = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_flag)">
      <mask
        id="mask0_flag"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_flag)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 11.4287H24V17.143H0V11.4287Z"
          fill="#007100"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6804 8.22885C13.7033 8.33971 13.7147 8.45399 13.7147 8.57171C13.7147 9.51799 12.9467 10.286 12.0004 10.286C11.0541 10.286 10.2861 9.51799 10.2861 8.57171C10.2861 8.45399 10.2976 8.33971 10.3204 8.22885C10.4804 8.74999 11.1707 9.14314 12.0004 9.14314C12.8301 9.14314 13.5204 8.74999 13.6804 8.22885ZM12.0004 8.00028C12.3158 8.00028 12.5718 7.74428 12.5718 7.42885C12.5718 7.11342 12.3158 6.85742 12.0004 6.85742C11.685 6.85742 11.429 7.11342 11.429 7.42885C11.429 7.74428 11.685 8.00028 12.0004 8.00028Z"
          fill="#F9CA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H24V5.71429H0V0Z"
          fill="#D20200"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_flag">
        <rect width="24" height="17.1429" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const flagKG = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_kg)">
      <mask
        id="mask0_kg"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_kg)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#EB0624"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6642 10.8396C11.7751 10.851 11.8871 10.8567 12.0002 10.8567C12.1145 10.8567 12.2254 10.851 12.3362 10.8396L12.0002 9.99958L11.6642 10.8396ZM10.1145 10.2167C9.51678 9.74358 9.14307 9.0533 9.14307 8.2853C9.14307 7.37901 9.66421 6.58244 10.4505 6.1253L11.4288 8.57101L10.1145 10.2167ZM13.5499 6.1253C14.3362 6.58244 14.8574 7.37901 14.8574 8.2853C14.8574 9.05444 14.4825 9.74472 13.8859 10.2167L12.5716 8.57101L13.5499 6.1253ZM13.4356 6.0613C13.0128 5.83958 12.5236 5.71387 12.0002 5.71387C11.4768 5.71387 10.9865 5.83958 10.5648 6.0613L12.0002 7.85558L13.4356 6.0613Z"
          fill="#FFF100"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9998 13.7144C14.8398 13.7144 17.1426 11.4116 17.1426 8.57157C17.1426 5.73157 14.8398 3.42871 11.9998 3.42871C9.15979 3.42871 6.85693 5.73157 6.85693 8.57157C6.85693 11.4116 9.15979 13.7144 11.9998 13.7144ZM11.9998 12.5716C14.2089 12.5716 15.9998 10.7807 15.9998 8.57157C15.9998 6.36243 14.2089 4.57157 11.9998 4.57157C9.79065 4.57157 7.99979 6.36243 7.99979 8.57157C7.99979 10.7807 9.79065 12.5716 11.9998 12.5716Z"
          fill="#FFF100"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_kg">
        <rect width="24" height="17.1429" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const flagUZ = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_uz)">
      <mask
        id="mask0_uz"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_uz)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#D4112A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 12.5713H24V17.1427H0V12.5713Z"
          fill="#20BD42"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H24V4.57143H0V0Z"
          fill="#02A3BD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 5.71401H24V11.4283H0V5.71401ZM5.71429 4.47401C5.536 4.53686 5.34286 4.57115 5.14286 4.57115C4.19657 4.57115 3.42857 3.80315 3.42857 2.85686C3.42857 1.91058 4.19657 1.14258 5.14286 1.14258C5.34286 1.14258 5.536 1.17686 5.71429 1.23972C5.048 1.47515 4.57143 2.11058 4.57143 2.85686C4.57143 3.60315 5.048 4.23972 5.71429 4.47401Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.85742 2.28544H8.00028V3.42829H6.85742V2.28544ZM8.00028 1.14258H9.14314V2.28544H8.00028V1.14258ZM9.14314 2.28544H10.286V3.42829H9.14314V2.28544ZM10.286 1.14258H11.4289V2.28544H10.286V1.14258ZM11.4289 2.28544H12.5717V3.42829H11.4289V2.28544ZM10.286 3.42829H11.4289V4.57115H10.286V3.42829ZM8.00028 3.42829H9.14314V4.57115H8.00028V3.42829Z"
          fill="#78CDDB"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_uz">
        <rect width="24" height="17.1429" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const flagUA = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <mask id="mask0" maskType="alpha" x="0" y="0" width="24" height="18">
        <path
          d="M21.7143 0H2.2857C1.0234 0 0 1.0234 0 2.2857v12.5714C0 16.1196 1.0234 17.1429 2.2857 17.1429h19.4286C22.9766 17.1429 24 16.1196 24 14.8571V2.2857C24 1.0234 22.9766 0 21.7143 0z"
          fill="#fff"
        />
      </mask>

      <g mask="url(#mask0)">
        <path
          d="M21.7143 0H2.2857C1.0234 0 0 1.0234 0 2.2857v12.5714C0 16.1196 1.0234 17.1429 2.2857 17.1429h19.4286C22.9766 17.1429 24 16.1196 24 14.8571V2.2857C24 1.0234 22.9766 0 21.7143 0z"
          fill="#FFDA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0h24v9.1429H0V0z"
          fill="#0266C3"
        />
        <path
          d="M21.714.571H2.286C1.339.571.571 1.339.571 2.286v12.571c0 .947.768 1.714 1.714 1.714h19.428c.947 0 1.714-.767 1.714-1.714V2.286c0-.947-.767-1.715-1.714-1.715z"
          stroke="#000"
          strokeOpacity=".1"
          strokeWidth="1.143"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="17.143" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

const flagKZ = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <mask id="mask0" maskType="alpha" x="0" y="0" width="24" height="18">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#00AFCC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.286 2.851c0-.312.265-.566.571-.566.316 0 .572.247.572.566v2.297c0 .312-.265.566-.572.566a.57.57 0 01-.571-.566V2.851zm1.143 2.28c0-.312.265-.566.572-.566.316 0 .572.247.572.566v2.297c0 .312-.265.566-.572.566a.57.57 0 01-.572-.566V5.131zm0 4.571c0-.312.265-.566.572-.566.316 0 .572.247.572.566v2.297c0 .312-.265.566-.572.566a.57.57 0 01-.572-.566V9.702zM2.286 11.994c0-.312.265-.566.571-.566.316 0 .572.247.572.566v2.297c0 .312-.265.566-.572.566a.57.57 0 01-.571-.566v-2.297zM2.286 7.428c0-.316.265-.572.571-.572.316 0 .572.265.572.572 0 .316-.265.572-.572.572a.57.57 0 01-.571-.572zm1.143-4.571c0-.316.265-.572.572-.572.316 0 .572.265.572.572 0 .316-.265.572-.572.572a.57.57 0 01-.572-.572zM2.286 8.571c0-.316.265-.572.571-.572.316 0 .572.265.572.572 0 .316-.265.571-.572.571a.57.57 0 01-.571-.571zm1.143 5.714c0-.316.265-.572.572-.572.316 0 .572.265.572.572 0 .316-.265.572-.572.572a.57.57 0 01-.572-.572zM2.286 9.714c0-.316.265-.572.571-.572.316 0 .572.265.572.572 0 .316-.265.571-.572.571a.57.57 0 01-.571-.571z"
          fill="#DAC21D"
        />
        <path
          d="M13.143 10.286c1.578 0 2.857-1.279 2.857-2.857 0-1.578-1.279-2.857-2.857-2.857-1.578 0-2.857 1.279-2.857 2.857 0 1.578 1.279 2.857 2.857 2.857z"
          fill="#FFC600"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.143 8l1.143 2.286 2.857 1.143 2.857-1.143L17.143 8v3.429l-4 1.143-4-1.143V8z"
          fill="#FFC600"
        />
        <path
          d="M21.714.571H2.286C1.339.571.571 1.339.571 2.286v12.571c0 .947.768 1.714 1.714 1.714h19.429c.947 0 1.714-.767 1.714-1.714V2.286c0-.947-.767-1.715-1.714-1.715z"
          stroke="#000"
          strokeOpacity=".1"
          strokeWidth="1.143"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="17.1429" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

const flagTR = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4123_5343)">
      <mask
        id="mask0_4123_5343"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_4123_5343)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#E70B17"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0021 9.88776L14.6741 10.5849L14.9278 9.10719L13.8535 8.05919L15.3392 7.84205L16.0021 6.49805L16.6649 7.84319L18.1507 8.06033L17.0764 9.10605L17.3301 10.5838"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.8574 12.5713C13.0666 12.5713 14.8574 10.7804 14.8574 8.57129C14.8574 6.36215 13.0666 4.57129 10.8574 4.57129C8.64828 4.57129 6.85742 6.36215 6.85742 8.57129C6.85742 10.7804 8.64828 12.5713 10.8574 12.5713ZM12.0003 11.4284C13.5774 11.4284 14.8574 10.1484 14.8574 8.57129C14.8574 6.99415 13.5774 5.71415 12.0003 5.71415C10.4231 5.71415 9.14314 6.99415 9.14314 8.57129C9.14314 10.1484 10.4231 11.4284 12.0003 11.4284Z"
          fill="white"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4123_5343">
        <rect width="24" height="17.1429" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const flagEE = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4123_5518)">
      <mask
        id="mask0_4123_5518"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_4123_5518)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 11.4287H24V17.143H0V11.4287Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H24V5.71429H0V0Z"
          fill="#448FDC"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4123_5518">
        <rect width="24" height="17.1429" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const flagIT = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H8V17.1429H0V0Z"
          fill="#009342"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 0H24V17.1429H16V0Z"
          fill="#D02832"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="17.1429" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

const flagPL = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#DF0A37"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H24V9.14286H0V0Z"
          fill="#fff"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="17.1429" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

const flagES = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#CD0B20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 4.57129H24V12.5713H0V4.57129Z"
          fill="#FFCB00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2856 7.10978V9.98978C10.2856 10.7898 9.51757 11.4298 8.57129 11.4298H6.28557C5.34157 11.4275 4.57129 10.7841 4.57129 9.9875V7.1075C4.57129 6.45378 5.08329 5.9075 5.78729 5.73035C5.99986 5.13607 6.65357 5.66864 7.42843 5.66864C8.20786 5.66864 8.857 5.1395 9.06957 5.7315C9.77129 5.91321 10.2856 6.46064 10.2856 7.10978Z"
          fill="#C8B47C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2859 8H11.4287V11.4286H10.2859V8ZM3.42871 8H4.57157V11.4286H3.42871V8Z"
          fill="#B5B5B5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2859 10.2852H11.4287V11.428H10.2859V10.2852ZM3.42871 10.2852H4.57157V11.428H3.42871V10.2852Z"
          fill="#165C96"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2859 6.85742H11.4287V8.00028H10.2859V6.85742ZM3.42871 6.85742H4.57157V8.00028H3.42871V6.85742Z"
          fill="#A0790A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.71387 6.85742H6.85672V8.57171H5.71387V6.85742ZM7.99958 9.14314H9.14244V10.8574H7.99958V9.14314Z"
          fill="#D20636"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 6.85742H9.14286V8.57171H8V6.85742Z"
          fill="#A18793"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.71387 9.14258H6.85672V10.8569H5.71387V9.14258Z"
          fill="#FFE100"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.85672 6.85672L5.71387 5.71387H9.14244L7.99958 6.85672H6.85672Z"
          fill="#B6161A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.85742 4.57129H8.00028V5.71415H6.85742V4.57129Z"
          fill="#AC9300"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="17.1429" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

const flagFR = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4123_5358)">
      <mask
        id="mask0_4123_5358"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
        style={{ maskType: "alpha" }}
      >
        <path
          d="M21.7143 0H2.2857C1.0233 0 0 1.0233 0 2.2857v12.5714C0 16.1195 1.0233 17.1429 2.2857 17.1429h19.4286C22.9767 17.1429 24 16.1195 24 14.8571V2.2857C24 1.0233 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#mask0_4123_5358)">
        <path
          d="M21.7143 0H2.2857C1.0233 0 0 1.0233 0 2.2857v12.5714C0 16.1195 1.0233 17.1429 2.2857 17.1429h19.4286C22.9767 17.1429 24 16.1195 24 14.8571V2.2857C24 1.0233 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0h8v17.1429H0V0Z"
          fill="#001C98"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 0h8v17.1429h-8V0Z"
          fill="#F02532"
        />
        <path
          d="M21.7141.5713H2.2856c-.9468 0-1.7143.7675-1.7143 1.7143v12.5714c0 .9468.7675 1.7143 1.7143 1.7143h19.4285c.9468 0 1.7143-.7675 1.7143-1.7143V2.2856c0-.9468-.7675-1.7143-1.7143-1.7143Z"
          stroke="#000"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4123_5358">
        <rect width="24" height="17.1429" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

const flagGE = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4123_5361)">
      <mask
        id="mask0_4123_5361"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
        style={{ maskType: "alpha" }}
      >
        <path
          d="M21.7143 0H2.2857C1.0233 0 0 1.0233 0 2.2857v12.5714C0 16.1195 1.0233 17.1429 2.2857 17.1429h19.4286C22.9767 17.1429 24 16.1195 24 14.8571V2.2857C24 1.0233 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#mask0_4123_5361)">
        <path
          d="M21.7143 0H2.2857C1.0233 0 0 1.0233 0 2.2857v12.5714C0 16.1195 1.0233 17.1429 2.2857 17.1429h19.4286C22.9767 17.1429 24 16.1195 24 14.8571V2.2857C24 1.0233 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2857 10.2857H0V6.8571h10.2857V0h3.4286v6.8571H24v3.4286H13.7143v6.8572h-3.4286v-6.8572Z"
          fill="#FF0000"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.1427 12.5709h-1.1428v1.1428h1.1428v1.1429h1.1429v-1.1429h1.1428v-1.1428h-1.1428v-1.1429h-1.1429v1.1429Zm0-9.1429h-1.1428v1.1429h1.1428v1.1429h1.1429V4.5709h1.1428V3.428h-1.1428V2.2851h-1.1429V3.428Zm-11.4286 0H4.5713v1.1429h1.1428v1.1429H6.857V4.5709h1.1429V3.428H6.857V2.2851H5.7141V3.428Zm0 9.1429H4.5713v1.1428h1.1428v1.1429H6.857v-1.1429h1.1429v-1.1428H6.857V11.428H5.7141v1.1429Z"
          fill="#FF0000"
        />
        <path
          d="M21.7141.5713H2.2856c-.9468 0-1.7143.7675-1.7143 1.7143v12.5714c0 .9468.7675 1.7143 1.7143 1.7143h19.4285c.9468 0 1.7143-.7675 1.7143-1.7143V2.2856c0-.9468-.7675-1.7143-1.7143-1.7143Z"
          stroke="#000"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4123_5361">
        <rect width="24" height="17.1429" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
